import { httpAuthRequest } from '@/services'

const state = {
  profiles: [],
  ownProfile: null,
  profilesToInvite: []
}

const actions = {
  async getProfiles({ commit }) {
    const response = await httpAuthRequest('get', '/profiles/')
    if (response.success) commit('SET_PROFILES', response.data)
    return response.success
  },
  // http://localhost:8000/api/profiles/?own_profile=True
  async getOwnProfile({ commit }) {
    const response = await httpAuthRequest('get', '/profiles/?own_profile=True')
    if (response.success) commit('SET_OWN_PROFILE', response.data)
    return response.success
  },
  // event_to_invite=event_id
  async getProfileToInvite({ commit }, payload) {
    const response = await httpAuthRequest('get', '/profiles/?event_to_invite=' + payload)
    if (response.success) commit('SET_PROFILES_TO_INVITE', response.data)
    return response.success
  },
  async updateProfile({ commit }, payload) {
    const response = await httpAuthRequest('patch', `/profiles/${payload.id}/`, payload)
    if (response.success) {
      commit('SET_ALERT', { type: 'success', message: 'Profile has been updated successfully' })
      commit('SET_OWN_PROFILE', response.data)
      return response.success
    }
    else commit('SET_CREATE_EVENT_ERROR', response.data)

    return response
  },

  async getSearchProfiles({ commit }, payload) {
    const response = await httpAuthRequest('get', '/profiles/?search=' + payload)
    if (response.success) {
      commit('SET_PROFILES', response.data);
      commit('SET_PROFILES_TO_INVITE', response.data);
    }
    return response.success
  },
}

const mutations = {
  SET_PROFILES(state, profiles) {
    for (const profile of profiles.results) {
      state.profiles.push(profile)
    }
  },
  SET_PROFILES_TO_INVITE(state, profiles) {
    state.profilesToInvite = profiles.results
  },

  SET_OWN_PROFILE(state, profile) {
    if (typeof profile.results !== 'undefined' && typeof profile.results[0] !== 'undefined') {
      profile = profile.results[0]
    }
    state.ownProfile = profile
  },

  RESET_PROFILES(state) {
    state.profiles = [];
    state.ownProfile = null;
  },
}

export default {
  state,
  actions,
  mutations
}
